import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Leibrente from "./pages/Leibrente";
import Teilverkauf from "./pages/Teilverkauf";
import Rueckmiete from "./pages/Rueckmiete";
import Niessbrauch from "./pages/Niessbrauch";
import Wohnrecht from "./pages/Wohnrecht";
import Seniorenfinanzierung from "./pages/Seniorenfinanzierung";
import Erfolgsgeschichten from "./pages/Erfolgsgeschichten";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";
import AdminLogin from "./pages/AdminLogin";
import AdminSignup from "./pages/AdminSignup";
import AdminDashboard from "./pages/AdminDashboard";
import ClickTracker from "./components/ClickTracker";
import Footer from "./components/Footer";

const queryClient = new QueryClient();

const App = () => {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <ClickTracker />
            <div className="flex min-h-screen w-full flex-col bg-background">
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/leibrente" element={<Leibrente />} />
                  <Route path="/teilverkauf" element={<Teilverkauf />} />
                  <Route path="/rueckmiete" element={<Rueckmiete />} />
                  <Route path="/niessbrauch" element={<Niessbrauch />} />
                  <Route path="/wohnrecht" element={<Wohnrecht />} />
                  <Route path="/seniorenfinanzierung" element={<Seniorenfinanzierung />} />
                  <Route path="/erfolgsgeschichten" element={<Erfolgsgeschichten />} />
                  <Route path="/impressum" element={<Impressum />} />
                  <Route path="/datenschutz" element={<Datenschutz />} />
                  <Route path="/agb" element={<AGB />} />
                  <Route path="/admin" element={<AdminLogin />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin/signup" element={<AdminSignup />} />
                  <Route path="/admin/dashboard" element={<AdminDashboard />} />
                  {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
              <Footer />
            </div>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
};

export default App;
